import { parseElementFromString } from 'anodum';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';
import view from '../../view';

const createMediaContainer = (containerProps, imageAttrs, linkData) => {
  const liveDocument = view.accessors.getLiveDocument();
  const { defaultView } = liveDocument;
  const mediaTemplates = defaultView.customElements.get(IMAGE_SELECTOR).getTemplates();

  const containerAttrs = {
    contentPosition: '50% 50%',
    contentScale: '1',
    aspectRatio: '1',
    ...containerProps,
  };

  return parseElementFromString(
    mediaTemplates.imageMediaContainer(containerAttrs, imageAttrs, linkData)
  );
};

export default createMediaContainer;
